// String text
export const SUCCESSFUL_SIGNUP_PAGE_TITLE = 'SUCCESS!';

// String buttons
export const BACK_TO_SIGNIN_BTN_TEXT = "Back to sign in";
export const SUCCESSFUL_SIGNUP_PAGE_URL = '/success';
